import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../snackbar/snackbar.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-not-eligible',
  templateUrl: './profile-not-eligible.component.html',
  styleUrls: ['./profile-not-eligible.component.css']
})
export class ProfileNotEligibleComponent implements OnInit {

  constructor(private _router: Router, private dialogRef: MatDialogRef<ProfileNotEligibleComponent>){
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    
  }

  adjust() {
    console.log('eateat')
    console.log(this._router.url);
    const route = this._router.url;

    if (route.includes('healthcare'))
      this._router.navigate(['/clients/edit/healthcare']);
    if (route.includes('combined'))
      this._router.navigate(['/clients/edit/combined']);

    this.dialogRef.close();
  }

}
